import Vue from 'vue'
import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import OtpInput from '@bachdgvn/vue-otp-input'
import { showErrorToast, showSuccessToast } from '../../services/UI'
import UserService from '../../services/UserService'

Vue.component('v-otp-input', OtpInput)
export default {
  name: 'earningsModal',
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  data () {
    return {
      mutableActived: this.activated,
      otp: '',
      loading: false,
      timerCount: 30
    }
  },
  props: ['activated', 'closeEarningsModal', 'emailOrPhone'],
  // mounted () {
  //   console.log('this props:', this.props)
  // },
  methods: {
    handleFileChange (e) {
      this.$emit('input', e.target.files[0])
    },
    closePhone () {
      this.closeEarningsModal(true)
      this.mutableActived = !this.mutableActived
      this.$el.blur()
    },
    handleOnComplete (value) {
      console.log('OTP completed: ', value)
      this.otp = value
    },
    handleOnChange (value) {
      console.log('OTP changed: ', value)
    },
    async verifyOtp () {
      this.loading = true
      console.log('----', this.otp)
      if (this.otp.length < 4) {
        showErrorToast(this, 'Enter correct otp')
        return
      }
      const token = localStorage.getItem('emailorPhone-verify-token')
      console.log('token:::', token)
      const res = await UserService.verifyLoginWithEmailOrPhone(token, this.otp)
      console.log('res:', res)
      if (res) {
        if (this.$route.query.redirect != null) { this.$router.push(this.$route.query.redirect) } else this.$router.push({ path: 'Dashboard' })
        showSuccessToast(this, 'Login Successfull')
        this.loading = false
      } else {
        showErrorToast(this, 'Invalid Otp')
      }
    },
    async resendOtp () {
      const interval = setInterval(async () => {
        this.timerCount--
        if (this.timerCount <= 0) {
          clearInterval(interval)
          const resend = true
          const verifyToken = await UserService.verifyEmailOrPhone(this.emailOrPhone, resend)
          if (verifyToken) {
            this.timerCount = 30
            showSuccessToast(this, 'Otp sent to your mobile')
          } else {
            this.error = 'Unable to send OTP mobile.'
            showErrorToast(this, this.error)
          }
        } else {
          showErrorToast(this, `please wait for ${this.timerCount--}`)
        }
      }, 1000)
    }
  },
  watch: {
    activated (oldVal, newVal) {
      if (oldVal !== newVal && oldVal !== null) {
        this.mutableActived = !this.mutableActived
        this.$el.tabIndex = 1
        this.$nextTick(function () {
          this.$el.focus()
        })
      }
      console.log('mobile::', this.emailOrPhone)
    },
    timerCount: {
      handler (value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--
          }, 1000)
        }
      },
      immediate: true // This ensures the watcher is triggered upon creation
    }
  }
}
